import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ isCheckedForOrderConfirmationEmail: string }>;

export const DispatchUpdateOrderConfirmationEmail: HandlerType = props => {
    props.dispatch({
        type: "Custom/AccountSettings/UpdateAccountSettings",
        isCheckedForOrderConfirmationEmail: props.parameter.isCheckedForOrderConfirmationEmail,
    });
};

export const chain = [DispatchUpdateOrderConfirmationEmail];

const updateOrderConfirmationEmail = createHandlerChainRunner(chain, "updateOrderConfirmationEmail");
export default updateOrderConfirmationEmail;
